/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Map_Note_PlanInputs */

const en_us2_progress_extra_map_note_plan = /** @type {(inputs: Progress_Extra_Map_Note_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A target counts 1 set, a synergist ½. The colour compares with your plan's weekly target, never below 4 sets.`)
};

const pt_br2_progress_extra_map_note_plan = /** @type {(inputs: Progress_Extra_Map_Note_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alvo conta 1 série, sinergista conta ½. A cor compara com a meta semanal do seu plano, com piso de 4 séries.`)
};

const es_419_progress_extra_map_note_plan = /** @type {(inputs: Progress_Extra_Map_Note_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un objetivo cuenta 1 serie, un sinergista ½. El color se compara con la meta semanal de tu plan, con un mínimo de 4 series.`)
};

const pt_pt2_progress_extra_map_note_plan = /** @type {(inputs: Progress_Extra_Map_Note_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um alvo conta 1 série, um sinergista conta ½. A cor compara com o objetivo semanal do teu plano, com um mínimo de 4 séries.`)
};

const fr_fr2_progress_extra_map_note_plan = /** @type {(inputs: Progress_Extra_Map_Note_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un muscle cible compte 1 série, un synergiste ½. La couleur compare à l'objectif hebdomadaire de ton programme, avec un minimum de 4 séries.`)
};

const de_de2_progress_extra_map_note_plan = /** @type {(inputs: Progress_Extra_Map_Note_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Zielmuskel zählt 1 Satz, ein Synergist ½. Die Farbe vergleicht mit dem Wochenziel deines Plans, nie unter 4 Sätzen.`)
};

const it_it2_progress_extra_map_note_plan = /** @type {(inputs: Progress_Extra_Map_Note_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un muscolo principale conta 1 serie, un sinergico ½. Il colore confronta con l'obiettivo settimanale della tua scheda, mai sotto le 4 serie.`)
};

/**
* | output |
* | --- |
* | "A target counts 1 set, a synergist ½. The colour compares with your plan's weekly target, never below 4 sets." |
*
* @param {Progress_Extra_Map_Note_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_map_note_plan = /** @type {((inputs?: Progress_Extra_Map_Note_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Map_Note_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_map_note_plan(inputs)
	if (locale === "es-419") return es_419_progress_extra_map_note_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_map_note_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_map_note_plan(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_map_note_plan(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_map_note_plan(inputs)
	return en_us2_progress_extra_map_note_plan(inputs)
});
export { progress_extra_map_note_plan as "progress-extra.map_note_plan" }